import { render, staticRenderFns } from "./QuoteArchiveTable.vue?vue&type=template&id=6ef44602&scoped=true&"
import script from "./QuoteArchiveTable.vue?vue&type=script&lang=ts&"
export * from "./QuoteArchiveTable.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteArchiveTable.vue?vue&type=style&index=0&id=6ef44602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef44602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VDataTable,VSpacer})
